import React from "react";
import ErrorText from "../ErrorText/ErrorText";

interface IAuthForm {
  label?: string;
  icon?: any;
  id?: string;
  register: any;
  name: string;
  type: string;
  placeholder: string;
  errors: any;
  required: boolean;
  border?: boolean;
}

const FormInput: React.FC<IAuthForm> = ({
  label,
  icon,
  id,
  register,
  name,
  type,
  placeholder,
  errors,
  required,
  border = true,
}) => {
  return (
    <div className="w-full">
      <label
        className={`flex items-center gap-2 w-full bg-white ${
          border ? "border border-gray-300" : ""
        } rounded-md px-4 py-2 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:border-indigo-500 shadow-sm`}
      >
        {icon}
        <input
          id={id}
          {...register(`${name}`, { required: required })}
          type={type}
          className="w-full bg-transparent outline-none placeholder-gray-500 text-gray-900"
          placeholder={placeholder}
        />
      </label>
      <div className="mt-2">
        {errors[name] && (
          <ErrorText
            message={errors[name].message || "This field is required"}
          />
        )}
      </div>
    </div>
  );
};

export default FormInput;
